export const data = {
    labels: [''],
    datasets: [
        {
            label: 'Soll',
            data: [0],
            backgroundColor: "rgba(251, 191, 36, 0.7)",
        },
        {
            label: 'Ist',
            data: [0],
            backgroundColor: "rgba(34, 197, 94, 0.85)",
        }
    ]
};